import { Customizer } from "./products/customizer/views/customizer";
import { ProductVariations } from "./products/customizer/collections/product-variations";
import { ProductVariation } from "./products/customizer/models/product-variation";
import { CartProduct } from "./products/cart/models/cart_item";
import { CustomizerFooter } from "./products/customizer/views/customizer-footer";

var productConfigurator, product_data; /* hasWood, hasMetal, hasFabric,  */ 
var debugging = true;
if ( typeof window.debugging !== 'undefined' ) {
    debugging = window.debugging;
}
window.debugData = [];
window.customLogger = function(){
    
    if ( debugging ) {
        for (var i = 0; i < arguments.length; ++i){
            window.debugData.push( arguments[i] ); 
        }
    }
};

( function( $, window ){
    
    // window.customLogger( 'Customizer here!', window.product_data );
    product_data = window.product_data;
    

    $( document ).ready( function(){

        var item = product_data.variations.length ? product_data.variations[0]: {  name: product_data.family, sku: product_data.sku };
        item.family = product_data.family;
        // Default colors that need to be shown on a product (parameters are case insensitive)
        // Possible values for the first parameter are: metal, wood, fabric
        
        window.customLogger( product_data.swatch_types );
        if ( typeof item.options === 'undefined' ) {
            // this doesn't have variations, let's just get the swatch data;
            item.options = [];
            
            for ( var key in product_data.swatch_types ) {
                if ( !_.isEmpty( product_data.swatch_types[key] ) ) {
                    item.options.push( key );
                }
            }
        }
        let variations = new ProductVariations();

        product_data.variations.forEach(function( v ){
            v.family = product_data.family;
            let variation = new ProductVariation( v );
            variations.add( variation );
        });
        

        let opts = { 
            'post_id' : product_data.post_id,
            'link' : product_data.link,
            'image' : product_data.image,
            'name': item.name, 
            'product_family': item.family, 
            'parent_sku' : item.sku,
            'sku': item.sku,
            'settings' : {},
            'variation' : item,
            'swatch_exclusions' : product_data.swatch_exclusions,
            'outdoor' : product_data.outdoor,
			'editing' : false
        };

        item.options.forEach( function( option ){
            let type = option.type.slug;
            if ( typeof product_data.swatch_types[type].swatches[0] !== 'undefined' ) {
                opts.settings[type] = '';
            }
        } );

        // maybe load configuration model settings here.
        var hashVariables = window.location.hash.length ? window.location.hash.substr(2).split( '/' ) : '';
        var params = {};
        var existingProductFlag = false;
        if ( hashVariables ) {
            _.each( hashVariables, function( paramStr )  {
                var parts = paramStr.split( ':' );
                
                if ( parts.length === 2 ) {
                    var key = parts[0];
                    var val = parts[1];
                    params[key] = val;
                } 
                // else continue on to the next
            } );
            if ( typeof params.cart_config !== 'undefined' ) {
                // console.log( params.cart_config );
                var x = params.cart_config;
                var existingProduct = window.cart.getCartProduct( x );
                
                if ( typeof existingProduct === 'undefined' || _.isEmpty( existingProduct ) ) {
                    alert( 'Product not found' );
                }
                else if ( existingProduct.get( 'post_id' ) === product_data.post_id ) {
                    opts = JSON.parse( JSON.stringify( existingProduct.toJSON() ) ); 
                    opts.cart_id = params.cart_config;
                    existingProductFlag = true;
                    // $( 'a.request-a-quote', this.el ).text( 'Update Request' );
                } else {
                    alert( 'Product does not match' );
                }
                
            } else {

				if ( !_.isEmpty(params) ) {
					_.each( params, function( val, key ){
						
						switch ( key ) {
							case 'sku':
								var variation = variations.find({ sku : val });
								if ( variation ) {
									opts['sku'] = val;
									opts['variation'] = variation.toJSON();
									opts['name'] = variation.get('name');
									opts['image'] = variation.get('image');
								} else {
									alert( 'Variation not found' );
								}
								break;
							case 'quantity':
								// console.log( key, val );
								opts[key] = val;
								break;
							default:
								var c = val.replace( /-/g, ' ' );
								opts.settings[key] = c;
								break;
						}
					});
				}
            }

			if ( !_.isEmpty(params) ) {
				opts['editing'] = true;
			}
            
            $('html, body').animate({
                scrollTop: $("#customization-section").offset().top
            }, 2000);


        }

        // end load configuration model
        if ( product_data.configurator ) {

            // var appendConfigScript = function( script ){
            //     var s = document.createElement("script");
            //     s.type = "text/javascript";
            //     s.src = product_data.template_url + '/configurator/' + script + '.bundle.js?v=2';
            //     document.body.appendChild(s);
            // };

            // var configScripts = [ 'inline', 'polyfills', 'scripts', 'main' ];
            // configScripts.forEach(appendConfigScript);

            var appendConfigScript = function(scriptName, callback) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = product_data.template_url + "/configurator/" + scriptName + ".bundle.js?v=2";
                // Event listener for when the script has finished loading
                script.onload = function() {
                    // Call the callback function if provided
                    if (typeof callback === "function") {
                        callback();
                    }
                };
            
                // Append the script to the body
            
                document.body.appendChild(script);
            
            };
            
            // Function to load scripts in sequence
            var loadScriptsSequentially = function(scripts, index) {
                if (index < scripts.length) {
                    appendConfigScript(scripts[index], function() {
                        // Load the next script after the current one finishes loading
                        loadScriptsSequentially(scripts, index + 1);
                    });
                }
            };
            
            // Start loading the scripts
            
            loadScriptsSequentially(["inline", "polyfills", "scripts", "main"], 0);

            window.setBase = function (loader) {
                // Data Source
                //window.customLogger( loader );
                
                var x = 'v03.27.2025';
                loader.setBase({url: product_data.template_url + '/configurator/assets/data/data1.json?v=' + x});
                loader.setConfig({
                    url: product_data.template_url +"/configurator/assets/data/dataConfig.json?v=" + x
                });
            };
            

            window.apiReady = function (api) {
                // General configurator settings
                // window.customLogger( product_data );
                api.setConfig({
                    // Source of the reduced size configurator images
                    rawImagesLow:'https://grandrapidschair.dreamsoft.us/sd/',
                    // Source of the full size configurator images
                    rawImagesHigh: 'https://grandrapidschair.dreamsoft.us/hd/',
                    // Configurator cache folder
                    finalImages: 'https://grandrapidschair.dreamsoft.us/render/',
                    // Default rotation frame of the product
                    firstFrame:0,
                    totalFrames:8
                });
                
                // Family and SKU that need to be displayed (parameters are case insensitive)
                api.selectSku( opts.product_family, opts.sku );

                if ( !_.isEmpty(opts.settings) ) {
                    Object.keys(opts.settings).forEach( function( type ){
                        var val = opts.settings[type];
						var swatch;
						if ( typeof _.findWhere === 'undefined' ) {
							swatch =  _.find( product_data.swatch_types[type].swatches, { name: val } );
						} else {
							swatch =  _.findWhere( product_data.swatch_types[type].swatches, { name: val } );
						}
						if ( swatch ) {
							val = swatch.code;
						}
                        api.selectColor( type, val );
                    });
                } else {
                    item.options.forEach( function( option ){
                        let type = option.type.slug;
                        if ( typeof product_data.swatch_types[type].swatches[0] !== 'undefined' ) {
                            // window.customLogger( type, product_data.swatch_types[type][0]  );
                            api.selectColor( type, product_data.swatch_types[type].swatches[0].code );
                        }
                    } );
                }
                
                productConfigurator = api;
                window.productConfigurator = productConfigurator;
                $( document ).trigger( 'configurator-loaded' );
            };

        } else if ( opts.image ) {
            var image_url = opts.image;
            document.getElementById('customizer-preview-photo').src = image_url;
            document.getElementById('customizer-preview-photo').srcset = image_url;
        }

        // console.log( opts );
            

            let product = new CartProduct( opts );
            // window.customLogger( swatchTemplate( { name:'Example' } ), swatch, variations );
            let configuratorView = new Customizer( { 
                'model': product,
                'collection': variations, 
                'product_data': product_data 
            } );
            configuratorView.render();

            let customizerFooter = new CustomizerFooter( { 
                'model': product, 
                'existing': existingProductFlag, 
                'product_data': product_data
            } );
            customizerFooter.render();

            window.customizerFooter = customizerFooter;
            
    });
})( jQuery, window );